/* TRATHAM — carrinho lateral: teclado para os controles customizados do Vision (Fechar e Remover) */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  const control = event.target.closest?.('#Cart-Drawer side-panel-close, #Cart-Drawer cart-remove');
  if (!control) return;
  event.preventDefault();
  control.click();
});

/* TRATHAM: adicionar recomendação direto da sacola ("+" abre os tamanhos) — 2026-10-27.
   Usa /cart/add com as seções do Vision (cart-drawer, cart-bubble, main-cart) e re-renderiza a sacola aberta. */
if (!customElements.get('tr-cart-add')) {
  customElements.define('tr-cart-add', class extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const toggle = e.target.closest('button[aria-expanded]');
        if (toggle) return this.toggle(toggle);
        const btn = e.target.closest('button[data-id]');
        if (btn && !btn.disabled && !this.hasAttribute('aria-busy')) this.add(btn);
      });
      this.addEventListener('keydown', (e) => {
        const toggle = this.querySelector('button[aria-expanded="true"]');
        if (e.key === 'Escape' && toggle) {
          e.stopPropagation();
          this.closingSizes = true;
          this.toggle(toggle);
          toggle.focus();
        }
      });
      /* O Esc que fecha os tamanhos não fecha a sacola (o Vision fecha painéis no keyup do documento) */
      this.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && this.closingSizes) {
          e.stopPropagation();
          this.closingSizes = false;
        }
      });
    }

    /* Um seletor de tamanhos aberto por vez */
    toggle(btn) {
      const open = btn.getAttribute('aria-expanded') !== 'true';
      if (open) {
        document.querySelectorAll('#Cart-Drawer tr-cart-add button[aria-expanded="true"]').forEach((b) => {
          if (b !== btn) b.closest('tr-cart-add')?.toggle(b);
        });
      }
      btn.setAttribute('aria-expanded', String(open));
      const sizes = document.getElementById(btn.getAttribute('aria-controls'));
      if (!sizes) return;
      sizes.hidden = !open;
      if (open) sizes.querySelector('button:not([disabled])')?.focus({ preventScroll: true });
    }

    add(btn) {
      const status = this.querySelector('.tr-cart__rec-error');
      const sections = [
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' }
      ];
      this.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
      if (status) status.textContent = '';

      const body = new FormData();
      body.append('id', btn.dataset.id);
      body.append('quantity', 1);
      body.append('sections', sections.map((s) => s.section));
      body.append('sections_url', window.location.pathname);

      fetch(window.theme?.routes?.cart_add_url || '/cart/add', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) {
            if (status) status.textContent = res.description || this.dataset.error;
            return;
          }
          sections.forEach((s) => {
            const host = document.getElementById(s.id);
            const html = res.sections?.[s.section];
            if (!host || !html) return;
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
            const target = host.querySelector(s.selector) || host;
            if (fresh) target.innerHTML = fresh.innerHTML;
          });
          if (typeof dispatchCustomEvent === 'function') {
            dispatchCustomEvent('cart:item-added', { product: res, quantity: 1, context: 'cart-drawer' });
          }
          document.getElementById('Cart-Drawer')?.focus({ preventScroll: true });
        })
        .catch(() => { if (status) status.textContent = this.dataset.error; })
        .finally(() => {
          this.removeAttribute('aria-busy');
          btn.classList.remove('is-loading');
        });
    }
  });
}

/* TRATHAM: Enter no campo de cupom aplica o código — 2026-10-30 */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' || !event.target.matches('.tr-coupon__input')) return;
  event.preventDefault();
  event.target.closest('cart-discounts')?.querySelector('.cart-discounts--button')?.click();
});
